<template>
    <div class="frame-content">
        <div class="frame-content-wrap">
            <div class="datatable-wrap mt-10">
                <div class="topbar">
                    <div class="inline mr-8">
                        <el-button type="primary" :loading="exportLoading" :disabled="exportLoading" size="small" @click="handleExportList()">导出</el-button>
                    </div>
                </div>
                <div class="datatable">
                    <el-table
                        ref="curChargeTable"
                        :data="tableData"
                        v-loading="tableLoading"
                        element-loading-background="rgba(255, 255, 255, 0.3)"
                        border
                        height="600"
                        style="width: 100%">
                        <!-- <el-table-column
                            type="selection"
                            width="55"
                            align="center">
                        </el-table-column> -->
                        <el-table-column
                            fixed
                            prop="sortNum"
                            label="序号">
                        </el-table-column>
                        <el-table-column
                            prop="buildName"
                            label="楼栋号">
                        </el-table-column>
                        <el-table-column
                            prop="supplierName"
                            label="分包名称"
                            min-width="200">
                        </el-table-column>
                        <el-table-column
                            prop="floorName"
                            label="层数">
                        </el-table-column>
                        <el-table-column
                            prop="roomNum"
                            label="房间数量">
                        </el-table-column>
                        <el-table-column
                            prop="roomNameList"
                            label="房间明细">
                        </el-table-column>
                        <el-table-column
                            prop="workerNum"
                            label="工人数量">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '@/utils/common'
import http from '@/utils/http'
import {exportExcelWithImages} from '@/utils/excelExport'

export default {
    name: 'BuildCheckin',
    components: {},
    data() {
        return {
            filters: { },

            tableData: [],

            totalNum: 0,
            pageNum: 1,
            pageSize: 10000,

            curPageNum: 1,

            tableLoading: false,
            exportLoading: false,
        };
    },
    created () {
        this.org = this.getCurrentOrg();
        this.loadTable();
    },
    methods: {
        ...common,
        // 加载表格数据
        loadTable() {
            let params = {...this.filters};

            params.projectId = this.$store.state.org.id;
            params.pageNum = this.pageNum;
            params.pageSize = this.pageSize;

            this.tableLoading = true;
            http.get('v1/build/buildCheckinReport/list', {
                params: params
            }).then(req => {
                this.tableLoading = false;
                if (req.data.code == http.SUCCESS) {
                    let data = req.data.data;
                    this.tableData = data;
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.tableLoading = false;
                this.httpCatch(err);
            });
        },
        // 获取导出信息
        handleExportList(){
            this.exportLoading = true;
            this.$nextTick(() => {
                this.handleExport(this.tableData || []);
            });
        },
        async handleExport(exportList){
            try {
                let data = [
                    ['序号', '楼栋号', '分包名称', '层数', '房间数量', '房间明细', '工人数量'],
                ];
                exportList.map((item, index) => {
                    let itemData = [
                            index + 1,
                            item.buildName,
                            item.supplierName,
                            item.floorName,
                            item.roomNum,
                            item.roomNameList,
                            item.workerNum,
                        ]
                    data.push(itemData);
                });

                const images = [];
                
                exportExcelWithImages(data, images, `${this.org.name}楼栋入住信息.xlsx`);
                
                setTimeout(()=>{
                    this.exportLoading = false;
                    this.$message.success('导出成功');
                }, 5000);
            } catch (error) {
                this.exportLoading = false;
                this.$message.error('导出失败');
            }
        }
    }
}
</script>

<style scoped>
</style>
